import { useCoinThresholds } from '@/features/coin-event/hooks/use-coin-thresholds';

import { ThresholdDots } from './threshold-dots';

export const CoinEventProgressBar = () => { 
	const { 
		thresholds,
		achievedThreshold,
	} = useCoinThresholds();
	
	return (
		<div 
			className="shop-coin-progress"
			data-level={achievedThreshold?.ThresholdId ?? 0}
		>
			<div className="shop-coin-progress__content">
				<div className="shop-coin-progress__bar"></div>
				<ThresholdDots 
					thresholds={thresholds}
					achievedThreshold={achievedThreshold}
				/>
			</div>
		</div>
	);
};